import WebappComponent from "../components/WebappComponent";
import useWepapp from "../hook/useWepapp";

const MenuPage = ({

}) => {
    const hookapp = useWepapp()
    return <WebappComponent {...hookapp} />
}
export default MenuPage;